import api from './api';

const projectHoursService = {
    // Obter cargos disponíveis
    getAvailableRoles: () => api.get('/project-hours/roles'),

    // Obter horas de um projeto
    getProjectHours: (projectId) => api.get(`/project-hours/${projectId}`),

    // Salvar horas por cargo
    saveProjectHours: (projectId, hoursByRole) =>
        api.post(`/project-hours/${projectId}/save`, { hours_by_role: hoursByRole }),

    // Atualizar uma entrada de horas
    updateProjectHours: (projectId, hoursId, data) =>
        api.put(`/project-hours/${projectId}/${hoursId}`, data),

    // Atualizar status
    updateHoursStatus: (projectId, hoursId, status) =>
        api.patch(`/project-hours/${projectId}/${hoursId}/status`, { status }),

    // Excluir entrada de horas
    deleteProjectHours: (projectId, hoursId) =>
        api.delete(`/project-hours/${projectId}/${hoursId}`),

    // Obter projetos agendados para o calendário
    getScheduledProjects: (params) =>
        api.get('/project-hours/calendar', { params }),

    // Obter capacidade disponível
    getAvailableCapacity: (params) =>
        api.get('/project-hours/capacity', { params }),

    // Obter horas comprometidas por cargo
    getCommittedHours: (month) =>
        api.get('/project-hours/committed', { params: { month } })
};

export default projectHoursService;
